{
  "translation": {
    "validation": {
      "patientCommentTooLong": "Enter no more than {{count}} characters."
    },
    "landing": {
      "hero": {
        "title": "Register online"
      }
    }
  }
}
